import { useMemo } from 'react';

const Item = ({ onClick = () => {}, value, selected, children }) => {
    return (
        <button type="button" onClick={() => onClick(value)} className={`px-3 py-1 rounded whitespace-nowrap ${selected === value ? 'bg-primary text-white font-bold' : 'bg-gray-200'}`}>{children}</button>
    )
}

const TypeTabs = ({ onChange = () => {}, type, ...props }) => {
    const handleClick = (type) => {
        onChange && onChange(type);
    }

    const Tab = ({ children, value }) => useMemo(() => (
        <Item value={value} onClick={handleClick} selected={type}>{children}</Item>
    ), [handleClick, type, value, children]);

    return (
        <div {...props}>
            <Tab value="individual">Individual</Tab>
            <Tab value="group">Grupal</Tab>
            <Tab value="birthday">Cumpleaños</Tab>
            <Tab value="skating_class">Clase</Tab>
            <Tab value="products">Productos</Tab>
        </div>
    )
}

export default TypeTabs;